import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import { Loader2 } from "lucide-react";

// Landing is eager (entry/LCP); everything else is code-split so the
// landing bundle stays tiny and loads fast.
const Login = lazy(() => import("@/pages/Login"));
const MentorDashboard = lazy(() => import("@/pages/MentorDashboard"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const MobileUpload = lazy(() => import("@/pages/MobileUpload"));

const PageLoader = () => (
    <div className="flex min-h-screen items-center justify-center bg-hero-bg">
        <Loader2 className="animate-spin text-primary" />
    </div>
);

const Protected = ({ children, role }) => {
    const { user, ready } = useAuth();
    if (!ready) return <PageLoader />;
    if (!user) return <Navigate to="/login" replace />;
    if (role && user.role !== role) return <Navigate to={user.role === "super_admin" ? "/admin" : "/dashboard"} replace />;
    return children;
};

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Suspense fallback={<PageLoader />}>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/upload/:token" element={<MobileUpload />} />
                            <Route path="/dashboard" element={<Protected role="mentor"><MentorDashboard /></Protected>} />
                            <Route path="/admin" element={<Protected role="super_admin"><AdminDashboard /></Protected>} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </Suspense>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
